import Ajax from "@/api/ajax";
export default {
    //勾选增值服务 查询可用用优惠券
    getValueAddedServiceCoupons(params) {
        return Ajax.post("/Home/getValueAddedServiceCoupons", params);
    },
}